import { Step } from 'react-joyride';

export const overviewTourSteps: Step[] = [
  {
    target: 'body',
    content: (
      <div>
        <h3>Welcome to Your Dashboard! 👋</h3>
        <p>
          Let's take a quick tour to help you get started. You'll learn about the key features and
          how to navigate the platform effectively.
        </p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
    styles: {
      options: {
        width: 450
      }
    }
  },
  {
    target: '[data-tour="dashboard-welcome"]',
    content: (
      <div>
        <h4>Dashboard Overview</h4>
        <p>
          This is your main dashboard where you can see real-time metrics and performance
          indicators at a glance.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="nps-widget"]',
    content: (
      <div>
        <h4>Net Promoter Score (NPS)</h4>
        <p>
          Track customer satisfaction with your NPS score. This metric helps you understand how
          likely customers are to recommend your service.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="csat-widget"]',
    content: (
      <div>
        <h4>Customer Satisfaction (CSAT)</h4>
        <p>
          Monitor overall customer satisfaction levels. Higher scores indicate better customer
          experiences.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="metrics-widget"]',
    content: (
      <div>
        <h4>Key Metrics</h4>
        <p>
          View important metrics like response time, resolution rate, and conversation volume all
          in one place.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="queue-widget"]',
    content: (
      <div>
        <h4>Customer Queue</h4>
        <p>See how many customers are waiting to be served. Manage your queue efficiently here.</p>
      </div>
    ),
    placement: 'left'
  },
  {
    target: '[data-tour="agent-status-widget"]',
    content: (
      <div>
        <h4>Agent Status</h4>
        <p>Quick overview of agent availability - who's online, offline, or busy.</p>
      </div>
    ),
    placement: 'left'
  },
  {
    target: '[data-tour="engagement-widget"]',
    content: (
      <div>
        <h4>Engagement Metrics</h4>
        <p>Track customer engagement trends and interaction patterns over time.</p>
      </div>
    ),
    placement: 'left'
  }
];
